import React from "react"
import type { PropsWithChildren } from "react"
import { Button } from "./ui/button"
import { cn } from "../lib/utils"

type Props = {
  variant: "primary" | "secondary" | "inactive" | "destructive"
} & Omit<React.ComponentProps<typeof Button>, "variant">

export default function AppButton({
  variant,
  children,
  className,
  ...props
}: PropsWithChildren<Props>) {
  const clsName =
    variant === "primary"
      ? ""
      : variant === "secondary"
        ? "bg-white text-manual-green border-[1px] border-manual-green"
        : variant === "inactive"
          ? "bg-white text-manual-black hover:bg-hover-grey"
          : "bg-manual-red text-white"
  return (
    <Button
      variant={variant === "primary" ? "default" : null}
      className={cn("font-bold", clsName, className)}
      {...props}
    >
      {children}
    </Button>
  )
}
